import React, { useEffect, useRef, useState } from 'react';
import { FaGithub, FaLinkedin, FaGitAlt, FaRobot, FaCircleArrowLeft, FaCircleArrowRight, FaDiscord } from "react-icons/fa6";
import { NavLink, Link, useLocation } from 'react-router-dom';
import smallLogo from '../../media/img/ds-code-logo-small.svg';
import '../../css/common/floating-header.css';

// Added props: currentPage, setCurrentPage
function FloatingHeader({ showImmediately = false, heroHeight = 0, currentPage, setCurrentPage }) {
    const navRef = useRef(null);
    const [isVisible, setIsVisible] = useState(showImmediately);
    const [menuOpen, setMenuOpen] = useState(false);
    
    // Use useLocation hook to get the current path
    const location = useLocation();
    const isPortfolioPage = location.pathname === '/portfolio';

    useEffect(() => {
        if (showImmediately) {
            setIsVisible(true);
            return;
        }

        const handleScroll = () => {
            const scrollY = window.scrollY;
            setIsVisible(scrollY > heroHeight);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [showImmediately, heroHeight]);

    // *************************************************

    return (
        <nav ref={navRef} className={`no-select floating-nav ${isVisible ? 'visible' : ''}`}>
            <div className="nav-container container">
                <Link to="/">
                    <img src={smallLogo} class="ds-code-logo-small" alt="DS CODE"></img>
                </Link>
                <button className="burger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
                    <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
                    <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
                    <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
                </button>
                <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
                    <li><NavLink to="/" exact="true" className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink></li>
                    <li><NavLink to="/playground" className={({ isActive }) => isActive ? 'active' : ''}>Work</NavLink></li>
                    <li><NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>Inbox</NavLink></li>
                    <li className="flex w-100px space-between">
                        <a 
                            href="https://github.com/dave-sommerville" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >
                            <FaGithub></FaGithub>
                        </a>
                        <a 
                            href="https://www.linkedin.com/in/dave-sommerville/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >                            
                            <FaLinkedin></FaLinkedin>
                        </a>
                        <a 
                            href="https://discord.com/users/ds_code" 
                            target="_blank" 
                            rel="noopener noreferrer"
                        >                            
                            <FaDiscord></FaDiscord>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default FloatingHeader;